import type { BespokeSpecItem } from './storeUtils';

export const BESPOKE_RETAILER_OPTION_PREFIX = 'bespoke-option-';

type CarServicePricing = {
  price?: {
    display?: { personalPrice?: number | null } | null;
    finance?: { personalPrice?: number | null } | null;
  } | null;
} | null;

// Retailer bespoke options (Showroom Settings > Retailer options) are never
// sent to the car service, so their finance exclusion can't show up as a
// price gap. Stock `U*` extras are sent and priced by the car service, so
// they must not count here.
export const hasBespokeRetailerExtras = (
  bespokeSpecItems: BespokeSpecItem[] | null | undefined
): boolean =>
  (bespokeSpecItems ?? []).some(({ optionId }) =>
    optionId?.startsWith(BESPOKE_RETAILER_OPTION_PREFIX)
  );

// Drives the finance-table "excluded Products and Services" copy. The car
// service reports finance-excluded extras as a display/finance price gap;
// bespoke retailer options are passed in separately.
export const detectFinanceExcludedOptions = (
  pricing: CarServicePricing | undefined,
  hasBespokeExtras = false
): boolean => {
  const display = pricing?.price?.display?.personalPrice;
  const finance = pricing?.price?.finance?.personalPrice;
  return (
    (display != null && finance != null && display !== finance) ||
    hasBespokeExtras
  );
};
